import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import CardImage from 'styled/ItemCard/CardImage';
import Title from 'styled/ItemCard/Title';
import CardsListItem from 'styled/ItemCard/CardsListItem';
import ItemInfo from 'styled/ItemCard/ItemInfo';

class GalleryItem extends React.PureComponent {
  get date() {
    return new Date(this.props.createdAt * 1000).toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Moscow',
    });
  }

  render() {
    return (
      <Link
        to={`/galleries/${this.props.id}`}
        style={{ textDecoration: 'none', color: '#fff' }}
      >
        <CardsListItem>
          <CardImage
            src={this.props.mainImageUrl}
            alt={this.props.title}
          />

          <ItemInfo>Фотографий: {this.props.imagesCount}</ItemInfo>

          <Title>{this.props.title}</Title>

          <ItemInfo style={{ marginBottom: '14px' }}>{this.props.createdAt && this.date}</ItemInfo>
        </CardsListItem>
      </Link>
    );
  }
}

GalleryItem.propTypes = {
  id: PropTypes.string.isRequired,
  mainImageUrl: PropTypes.string,
  imagesCount: PropTypes.number,
  title: PropTypes.string,
  createdAt: PropTypes.number,
};

GalleryItem.defaultProps = {
  mainImageUrl: '',
  imagesCount: 0,
  title: '',
  createdAt: null,
};

export default GalleryItem;
